import { render, staticRenderFns } from "./ManualOrderSettings.vue?vue&type=template&id=426500ad&scoped=true"
import script from "./ManualOrderSettings.vue?vue&type=script&lang=js"
export * from "./ManualOrderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426500ad",
  null
  
)

export default component.exports